var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1122 0.259644C13.5364 0.259644 12.1723 1.50152 11.4936 2.49429C10.8158 1.50152 9.45371 0.259644 6.88336 0.259644C3.80892 0.259644 0.5 2.30579 0.5 6.79831C0.5 8.56888 0.884415 9.97398 1.78522 11.4968C2.66211 12.979 4.51908 14.8057 7.30458 16.9264C8.39173 17.7541 9.39318 18.4504 10.0419 18.8888C11.2886 19.7314 11.3374 19.7401 11.488 19.7402C11.4957 19.7403 11.503 19.7404 11.5103 19.7404C11.6527 19.7404 11.7508 19.6951 12.9426 18.8936C13.5918 18.457 14.5941 17.7633 15.6822 16.9375C18.4712 14.821 20.3333 12.9905 21.217 11.4969C22.1163 9.97691 22.5 8.57162 22.5 6.79841C22.5 2.30579 19.1887 0.259644 16.1122 0.259644Z",
    fill: "#E83939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f679ef15.svg";
export { ForwardRef as ReactComponent };